<template>
  <div>
      <div class="columns">
          <div class="column has-text-centered">
              <h1 class="is-size-3 has-text-white">
                  USER ROLE MANAGER
              </h1>
          </div>
      </div>
      <div class="columns box has-background-dvolightgrey">
          <div class="column">
        <h1 class="has-text-white is-size-5">Add Roles</h1>
            <b-field label="Company To Add">
                <b-select expanded v-model="selectCompany" placeholder="Company">
                    <option class="has-text-white is-bold" selected="selected"> {{ selectCompany }}
                    </option>
                    <option class="has-text-white" v-for="option in companies" :value="option"
                        :key="option.id">
                        {{ option.name }}
                    </option>
                </b-select>
            </b-field>
            <b-field label="User To Add">
                <b-select expanded v-model="selectUser" placeholder="User">
                    <option class="has-text-white is-bold" selected="selected"> {{ selectUser }} </option>
                    <option class="has-text-white" v-for="option in users" :value="option" :key="option.id">
                        {{ option.email }}
                    </option>
                </b-select>
            </b-field>
            <b-field label="Role To Add ">
                <b-select expanded v-model="selectRole" placeholder="Role">
                    <option class="has-text-white is-bold" selected="selected"> {{ selectRole }} </option>
                    <option class="has-text-white" v-for="option in roles" :value="option" :key="option.id">
                        {{ option.name }}
                    </option>
                </b-select>
            </b-field>
            <div class="has-text-centered">
                <b-button @click="addCompanyRole()" class="is-dvogreen">Associate</b-button>
            </div>
            <h1 class="has-text-white is-size-5">Remove Roles</h1>
            <b-field label="Company To Remove User's Role From ">
                <b-select expanded v-model="removeCompany" placeholder="Company">
                    <option class="has-text-white is-bold" selected="selected"> {{ removeCompany }}
                    </option>
                    <option class="has-text-white" v-for="option in companies" :value="option"
                        :key="option.id">
                        {{ option.name }}
                    </option>
                </b-select>
            </b-field>
            <b-field label="User to Remove Role From ">
                <b-select expanded v-model="removeUser" placeholder="User" :disabled="!removeCompany">
                    <option class="has-text-white is-bold" selected="selected"> {{ removeUser }} </option>
                    <option class="has-text-white" v-for="option in removeUsers" :value="option"
                        :key="option.id">
                        {{option}}
                    </option>
                </b-select>
            </b-field>
            <b-field label="Role to Remove ">
                <b-select expanded v-model="removeRole" placeholder="Role" :disabled="!removeUser">
                    <option class="has-text-white is-bold" selected="selected"> {{ removeRole }} </option>
                    <option class="has-text-white" v-for="option in removeRoles" :value="option"
                        :key="option.id">
                        {{ option.name }}
                    </option>
                </b-select>
            </b-field>
            <div class="has-text-centered">
                <b-button class="is-danger" @click="removeCompanyRole()">Remove Role</b-button>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import { API  } from 'aws-amplify'
import { roleReader, personCompanyRoleHandler } from '../graphql/mutations'
import { companyReader, personReader, usersFromPersonCompanyRoleReader, rolesFromPersonCompanyRoleReader } from '../graphql/queries'
export default {
    data() {
        return {
            companies: [],
            users: [],
            roles: [],
            selectCompany: null,
            selectUser: null,
            selectRole: null,
            removeCompanies: [],
            removeUsers: [],
            removeRoles: [],
            removeCompany: null,
            removeUser: null,
            removeRole: null,
        }
    },
    watch: {
        removeCompany: async function () {
            if (this.removeCompany.id) {
                const company = {
                    company_id: this.removeCompany.id
                }
                company["request_type"] = "find_users_by_company"

                const temp = await API.graphql({
                    query: usersFromPersonCompanyRoleReader,
                    variables: {
                        input: company
                    }
                });
                this.removeUsers = temp.data.usersFromPersonCompanyRoleReader
                this.removeUser = null
                this.removeRole = null
            }
        },
        removeUser: async function () {
            if (this.removeUser.id) {
                const user = {
                    user_id: this.removeUser.id
                }
                user["request_type"] = "find_roles_by_user"

                const temp = await API.graphql({
                    query: rolesFromPersonCompanyRoleReader,
                    variables: {
                        input: user
                    }


                })
                this.removeRoles = temp.data.rolesFromPersonCompanyRoleReader
            }
        },
    },
    methods: {
        async addCompanyRole() {
            await API.graphql({
                query: personCompanyRoleHandler,
                variables: {
                    input: {
                        request_type: 'add',
                        company_id: this.selectCompany.id,
                        user_id: this.selectUser.id,
                        role_id: this.selectRole.id
                    }
                }
            });
        },
        async removeCompanyRole() {
            await API.graphql({
                query: personCompanyRoleHandler,
                variables: {
                    input: {
                        request_type: 'remove',
                        company_id: this.removeCompany.id,
                        user_id: this.removeUser.id,
                        role_id: this.removeRole.id
                    }
                }
            })

            this.removeCompany = null,
                this.removeUser = null,
                this.removeRole = null
        },
        async getCompanies() {
            const Companies = await API.graphql({
                query: companyReader,
                variables: {
                    input: {
                        request_type: 'read_all',
                        query_type: 'all'
                    }
                }
            });
            this.companies = Companies.data.companyReader;
        },
        async getRoles() {
            const Roles = await API.graphql({
                query: roleReader,
                variables: {
                    input: {
                        request_type: 'read_all'
                    }
                }
            });
            this.roles = Roles.data.roleReader;
        },
        async getUsers() {
            const Users = await API.graphql({
                query: personReader,
                variables: {
                    input: {
                        request_type: 'read_all'
                    }
                }
            });
            this.users = Users.data.personReader;
        },
    },
    beforeMount(){
        this.getCompanies();
        this.getRoles();
        this.getUsers();
    }
}
</script>

<style>

</style>